import React, { useCallback } from 'react'
import * as style from './index.module.css'
import { CtaButton } from '@/components/atoms/entrypoint'
import { navigate } from 'gatsby'
import { fireEvent } from '@/utils/activityLog'
import { useGetCurrentPath } from '@/utils/hooks/useGetCurrentPath'
import { ENTRY_LINK } from '@/utils/const'

/**
 * @file ConversionButton
 * @todo @see {@link https://github.com/sozo-japan/corporate/issues/125}　Entryのリンクを差し替える
 */
export const ConversionButton = (): React.JSX.Element => {
  const { currentPath } = useGetCurrentPath()

  const onClickContact = useCallback((): void => {
    fireEvent({
      event: 'clickCtaContactButton',
      parameters: {
        current_path: currentPath,
        next_path: '/contact',
      },
    })
    navigate('/contact')
  }, [currentPath])

  const onClickEntry = useCallback((): void => {
    fireEvent({
      event: 'clickCtaEntryButton',
      parameters: {
        current_path: currentPath,
      },
    })
    navigate(ENTRY_LINK)
  }, [currentPath])

  return (
    <div className={style.root}>
      <div className={style.recruit}>
        <div className={style.content}>
          <h3 className={style.subTitle}>{'“recruit”'}</h3>
          <h2 className={style.title}>{'Join Us!'}</h2>
          <p className={style.description}>
            {'私たちは一緒に働くメンバーを探しております!'}
          </p>
        </div>
        <CtaButton type="orangeTextEntry" onClick={onClickEntry} />
      </div>
      <div className={style.contact}>
        <div className={style.content}>
          <h3 className={style.subTitle}>{'“contact”'}</h3>
          <h2 className={style.title}>{'お気軽にお問い合わせください'}</h2>
          <p className={style.description}>
            {'業務提携等に関するお問い合わせはこちら'}
          </p>
        </div>
        <CtaButton type="blackTextContact" onClick={onClickContact} />
      </div>
    </div>
  )
}
